import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { SelectItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { IconService } from 'app/rest/icon.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { VehiclebrandService } from 'app/rest/vehiclebrand.service';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { ClientService } from 'app/rest/client.service';
import { I18nService } from 'app/services/i18n/i18n.service';

import VehicleBrand = Rest.VehicleBrand;
import { RestExt } from 'app/services/rest-client-extension';
import { Router } from '@angular/router';

@Component({
    selector: 'app-brand-form',
    templateUrl: './brand-form.component.html',
    styleUrls: ['./brand-form.component.scss'],
    providers: [VehiclebrandService, IconService, ClientService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BrandFormComponent
    extends EntityFormComponent<VehicleBrand>
    implements OnInit {
    noticeChannels: SelectItem[];
    channelsList: Rest.NoticeChannel[];
    title: string;
    /*Permissions */
    disableSave: boolean;
    disabeChangeStatus: boolean;

    brandID: number;

    brandImage: any;
    brandImageFile: any;
    brandEncodedImage: string;
    newBrandImage: Rest.Icon;

    entityEnumImageBrand: Rest.IconEntityAssociationEnum = "VEHICLE_BRAND";

    iconImage: Rest.Icon;

    // Preservation of relationships
    clientRequestContext: Rest.ListPaginationRequest;
    /* *************************** */
    @Input() filterByClient: boolean;

    constructor(
        private brandService: VehiclebrandService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        private authenticationService: AuthenticationService,
        private translate: TranslateService,
        private iconService: IconService,
        public translateService: TranslateService,
        private clientService: ClientService,
        public route: Router
    ) {
        super(brandService, notificationsService, i18n, authenticationService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    /**
     * Loads and evaluates all the necessary data before showing the form.
     *
     * @memberof BrandFormComponent
     */
    beforeShow() {
        // Presevation of relationships
        this.clientRequestContext = RestExt.firstPageRequestVehicleInventory();

        this.brandEncodedImage = '../../../../assets/images/UI_Elements/HD_transparent_picture.png'; //Reset the image to an empty png image from assets.

        this.brandID = this.entity.id;

        const profiles = this.authenticationService.user.rolesProfiles;
        this.disableSave = !profiles.some(rp => rp.profile.actions.some(a => a.name === 'INV_VEH_BRAND_UPDATE'));
        this.disabeChangeStatus = !profiles.some(rp => rp.profile.actions.some(a => a.name === 'INV_VEH_BRAND_DISABLE'));

        if (this.isNew) {
            this.title = this.translateService.instant('tableManagement.brands.createBrand');
        } else {
            this.title = this.translateService.instant('tableManagement.brands.editBrand');
            if (this.entity.logo != null) {
                this.brandEncodedImage = this.entity.logo.imageEncoded;
            }
        }
    }

    /**
     * Takes a local image, and communicates with the API, in order to 
     * restore the client image.
     *
     * @param {*} event
     * @memberof BrandFormComponent
     */
    imageChange(event): void {

        const reader = new FileReader();
        this.brandImage = event.target.files[0];
        reader.readAsDataURL(this.brandImage);
        reader.onload = (event: any) => {
            console.log(reader.result);
            this.brandEncodedImage = event.target.result;
        };
    }

    saveChanges() {
        this.messages = [];
        if(!this.route.url.includes("control-panel")){
            this.entity.client = this.authenticationService.user.client;
        }
        let brandString = JSON.stringify(this.entity);

        const that = this;
        if (this.isNew) {
            this.brandService
                .createBrand(brandString, this.brandImage)
                .then(
                    function (res) {
                        that.display = false;
                        that.return.emit(res);
                    },
                    (err) => {
                        console.log(err);
                        that.handleError(err, that);
                    }
                )
                .catch((e) => {
                    this.handleError(e, that);
                });
        } else {
            this.brandService
                .updateBrand(brandString, this.brandImage)
                .then(
                    function (res) {
                        that.display = false;
                        that.return.emit(res);
                    },
                    (err) => {
                        console.log(err);
                        that.handleError(err, that);
                    }
                )
                .catch((e) => {
                    this.handleError(e, that);
                });
        }
    }
}

